/* eslint-disable global-require, quote-props */
// Do not manually edit this file
// run make ./src/icons/map.ts to update

export const BRAND_ICONS = {
  'chat-bubble-brand': require('../../design-system/icons/brand/chat-bubble-brand.svg'),
  'document-brand': require('../../design-system/icons/brand/document-brand.svg'),
  'high-five-brand': require('../../design-system/icons/brand/high-five-brand.svg'),
};

export const CORE_ICONS = {
  'accessories': require('../../design-system/icons/core/accessories.svg'),
  'acoustic': require('../../design-system/icons/core/acoustic.svg'),
  'amps': require('../../design-system/icons/core/amps.svg'),
  'angle-down': require('../../design-system/icons/core/angle-down.svg'),
  'angle-left': require('../../design-system/icons/core/angle-left.svg'),
  'angle-right': require('../../design-system/icons/core/angle-right.svg'),
  'angle-up': require('../../design-system/icons/core/angle-up.svg'),
  'apple': require('../../design-system/icons/core/apple.svg'),
  'arrow-circle-down': require('../../design-system/icons/core/arrow-circle-down.svg'),
  'arrow-circle-left': require('../../design-system/icons/core/arrow-circle-left.svg'),
  'arrow-circle-right': require('../../design-system/icons/core/arrow-circle-right.svg'),
  'arrow-circle-up': require('../../design-system/icons/core/arrow-circle-up.svg'),
  'arrow-down': require('../../design-system/icons/core/arrow-down.svg'),
  'arrow-left': require('../../design-system/icons/core/arrow-left.svg'),
  'arrow-right': require('../../design-system/icons/core/arrow-right.svg'),
  'arrow-up': require('../../design-system/icons/core/arrow-up.svg'),
  'article-feed': require('../../design-system/icons/core/article-feed.svg'),
  'ban': require('../../design-system/icons/core/ban.svg'),
  'bank': require('../../design-system/icons/core/bank.svg'),
  'bars': require('../../design-system/icons/core/bars.svg'),
  'bass': require('../../design-system/icons/core/bass.svg'),
  'bell-o': require('../../design-system/icons/core/bell-o.svg'),
  'bell': require('../../design-system/icons/core/bell.svg'),
  'bolt': require('../../design-system/icons/core/bolt.svg'),
  'bookmark': require('../../design-system/icons/core/bookmark.svg'),
  'bucks': require('../../design-system/icons/core/bucks.svg'),
  'bump-icon-alt': require('../../design-system/icons/core/bump-icon-alt.svg'),
  'bump-icon': require('../../design-system/icons/core/bump-icon.svg'),
  'calendar': require('../../design-system/icons/core/calendar.svg'),
  'camera': require('../../design-system/icons/core/camera.svg'),
  'caret-down': require('../../design-system/icons/core/caret-down.svg'),
  'caret-left': require('../../design-system/icons/core/caret-left.svg'),
  'caret-right': require('../../design-system/icons/core/caret-right.svg'),
  'caret-up': require('../../design-system/icons/core/caret-up.svg'),
  'cart': require('../../design-system/icons/core/cart.svg'),
  'check-circle': require('../../design-system/icons/core/check-circle.svg'),
  'check-square-o': require('../../design-system/icons/core/check-square-o.svg'),
  'check-square': require('../../design-system/icons/core/check-square.svg'),
  'check': require('../../design-system/icons/core/check.svg'),
  'chevron-down': require('../../design-system/icons/core/chevron-down.svg'),
  'chevron-left': require('../../design-system/icons/core/chevron-left.svg'),
  'chevron-right': require('../../design-system/icons/core/chevron-right.svg'),
  'chevron-up': require('../../design-system/icons/core/chevron-up.svg'),
  'circle-o': require('../../design-system/icons/core/circle-o.svg'),
  'circle-thin': require('../../design-system/icons/core/circle-thin.svg'),
  'circle': require('../../design-system/icons/core/circle.svg'),
  'clipboard': require('../../design-system/icons/core/clipboard.svg'),
  'clock-o': require('../../design-system/icons/core/clock-o.svg'),
  'close': require('../../design-system/icons/core/close.svg'),
  'cloud-upload': require('../../design-system/icons/core/cloud-upload.svg'),
  'cogs': require('../../design-system/icons/core/cogs.svg'),
  'comment-o': require('../../design-system/icons/core/comment-o.svg'),
  'comment': require('../../design-system/icons/core/comment.svg'),
  'comments': require('../../design-system/icons/core/comments.svg'),
  'copy': require('../../design-system/icons/core/copy.svg'),
  'credit-cards': require('../../design-system/icons/core/credit-cards.svg'),
  'creditcard': require('../../design-system/icons/core/creditcard.svg'),
  'crop': require('../../design-system/icons/core/crop.svg'),
  'desktop': require('../../design-system/icons/core/desktop.svg'),
  'download': require('../../design-system/icons/core/download.svg'),
  'drums': require('../../design-system/icons/core/drums.svg'),
  'effects': require('../../design-system/icons/core/effects.svg'),
  'electric': require('../../design-system/icons/core/electric.svg'),
  'envelope': require('../../design-system/icons/core/envelope.svg'),
  'eur': require('../../design-system/icons/core/eur.svg'),
  'exchange': require('../../design-system/icons/core/exchange.svg'),
  'exclamation-circle': require('../../design-system/icons/core/exclamation-circle.svg'),
  'exclamation-triangle': require('../../design-system/icons/core/exclamation-triangle.svg'),
  'explore': require('../../design-system/icons/core/explore.svg'),
  'express-truck': require('../../design-system/icons/core/express-truck.svg'),
  'external-link': require('../../design-system/icons/core/external-link.svg'),
  'eye': require('../../design-system/icons/core/eye.svg'),
  'facebook-alt': require('../../design-system/icons/core/facebook-alt.svg'),
  'facebook': require('../../design-system/icons/core/facebook.svg'),
  'feed-add': require('../../design-system/icons/core/feed-add.svg'),
  'feed-added': require('../../design-system/icons/core/feed-added.svg'),
  'feed-alt': require('../../design-system/icons/core/feed-alt.svg'),
  'feed-o': require('../../design-system/icons/core/feed-o.svg'),
  'feed': require('../../design-system/icons/core/feed.svg'),
  'file-text-o': require('../../design-system/icons/core/file-text-o.svg'),
  'file-text': require('../../design-system/icons/core/file-text.svg'),
  'flag': require('../../design-system/icons/core/flag.svg'),
  'folk': require('../../design-system/icons/core/folk.svg'),
  'gbp': require('../../design-system/icons/core/gbp.svg'),
  'gear': require('../../design-system/icons/core/gear.svg'),
  'gift': require('../../design-system/icons/core/gift.svg'),
  'giftcard': require('../../design-system/icons/core/giftcard.svg'),
  'globe': require('../../design-system/icons/core/globe.svg'),
  'google-plus': require('../../design-system/icons/core/google-plus.svg'),
  'graph-network': require('../../design-system/icons/core/graph-network.svg'),
  'handshake': require('../../design-system/icons/core/handshake.svg'),
  'header-feed': require('../../design-system/icons/core/header-feed.svg'),
  'header-watch-list': require('../../design-system/icons/core/header-watch-list.svg'),
  'home': require('../../design-system/icons/core/home.svg'),
  'images': require('../../design-system/icons/core/images.svg'),
  'info-circle': require('../../design-system/icons/core/info-circle.svg'),
  'instagram': require('../../design-system/icons/core/instagram.svg'),
  'jpy': require('../../design-system/icons/core/jpy.svg'),
  'keyboards': require('../../design-system/icons/core/keyboards.svg'),
  'language': require('../../design-system/icons/core/language.svg'),
  'linux': require('../../design-system/icons/core/linux.svg'),
  'list': require('../../design-system/icons/core/list.svg'),
  'listing': require('../../design-system/icons/core/listing.svg'),
  'lock': require('../../design-system/icons/core/lock.svg'),
  'magic': require('../../design-system/icons/core/magic.svg'),
  'map-marker': require('../../design-system/icons/core/map-marker.svg'),
  'media': require('../../design-system/icons/core/media.svg'),
  'microphone': require('../../design-system/icons/core/microphone.svg'),
  'minus': require('../../design-system/icons/core/minus.svg'),
  'news-article': require('../../design-system/icons/core/news-article.svg'),
  'offer-icon': require('../../design-system/icons/core/offer-icon.svg'),
  'orchestra': require('../../design-system/icons/core/orchestra.svg'),
  'parts': require('../../design-system/icons/core/parts.svg'),
  'pencil': require('../../design-system/icons/core/pencil.svg'),
  'phone': require('../../design-system/icons/core/phone.svg'),
  'picture-o': require('../../design-system/icons/core/picture-o.svg'),
  'pinterest': require('../../design-system/icons/core/pinterest.svg'),
  'play-circle': require('../../design-system/icons/core/play-circle.svg'),
  'play': require('../../design-system/icons/core/play.svg'),
  'plus-circle': require('../../design-system/icons/core/plus-circle.svg'),
  'plus': require('../../design-system/icons/core/plus.svg'),
  'pref-seller-o': require('../../design-system/icons/core/pref-seller-o.svg'),
  'print': require('../../design-system/icons/core/print.svg'),
  'question-circle': require('../../design-system/icons/core/question-circle.svg'),
  'record-sleeve': require('../../design-system/icons/core/record-sleeve.svg'),
  'refresh': require('../../design-system/icons/core/refresh.svg'),
  'remove': require('../../design-system/icons/core/remove.svg'),
  'reply': require('../../design-system/icons/core/reply.svg'),
  'reverb-logo-circle': require('../../design-system/icons/core/reverb-logo-circle.svg'),
  'reverb-logo': require('../../design-system/icons/core/reverb-logo.svg'),
  'rotate-right': require('../../design-system/icons/core/rotate-right.svg'),
  'search-alt': require('../../design-system/icons/core/search-alt.svg'),
  'search': require('../../design-system/icons/core/search.svg'),
  'share': require('../../design-system/icons/core/share.svg'),
  'shield-alt': require('../../design-system/icons/core/shield-alt.svg'),
  'shield-check': require('../../design-system/icons/core/shield-check.svg'),
  'shield': require('../../design-system/icons/core/shield.svg'),
  'snapchat-ghost': require('../../design-system/icons/core/snapchat-ghost.svg'),
  'soundcloud': require('../../design-system/icons/core/soundcloud.svg'),
  'speaker': require('../../design-system/icons/core/speaker.svg'),
  'spinner': require('../../design-system/icons/core/spinner.svg'),
  'square-o': require('../../design-system/icons/core/square-o.svg'),
  'square': require('../../design-system/icons/core/square.svg'),
  'star-empty': require('../../design-system/icons/core/star-empty.svg'),
  'star-filled': require('../../design-system/icons/core/star-filled.svg'),
  'star-half': require('../../design-system/icons/core/star-half.svg'),
  'storefront': require('../../design-system/icons/core/storefront.svg'),
  'suitcase': require('../../design-system/icons/core/suitcase.svg'),
  'tachometer': require('../../design-system/icons/core/tachometer.svg'),
  'tag-alt': require('../../design-system/icons/core/tag-alt.svg'),
  'tag': require('../../design-system/icons/core/tag.svg'),
  'tags': require('../../design-system/icons/core/tags.svg'),
  'th': require('../../design-system/icons/core/th.svg'),
  'thumbs-down': require('../../design-system/icons/core/thumbs-down.svg'),
  'thumbs-up': require('../../design-system/icons/core/thumbs-up.svg'),
  'times-circle': require('../../design-system/icons/core/times-circle.svg'),
  'times': require('../../design-system/icons/core/times.svg'),
  'trash-o': require('../../design-system/icons/core/trash-o.svg'),
  'trash': require('../../design-system/icons/core/trash.svg'),
  'trending-up-arrow': require('../../design-system/icons/core/trending-up-arrow.svg'),
  'truck': require('../../design-system/icons/core/truck.svg'),
  'turntable': require('../../design-system/icons/core/turntable.svg'),
  'twitch': require('../../design-system/icons/core/twitch.svg'),
  'twitter': require('../../design-system/icons/core/twitter.svg'),
  'unsorted': require('../../design-system/icons/core/unsorted.svg'),
  'usd': require('../../design-system/icons/core/usd.svg'),
  'user-circle-o': require('../../design-system/icons/core/user-circle-o.svg'),
  'user-secret': require('../../design-system/icons/core/user-secret.svg'),
  'users': require('../../design-system/icons/core/users.svg'),
  'vinyl': require('../../design-system/icons/core/vinyl.svg'),
  'waveform': require('../../design-system/icons/core/waveform.svg'),
  'window-maximize': require('../../design-system/icons/core/window-maximize.svg'),
  'windows': require('../../design-system/icons/core/windows.svg'),
  'wristwatch': require('../../design-system/icons/core/wristwatch.svg'),
  'writeall': require('../../design-system/icons/core/writeall.svg'),
  'youtube-play': require('../../design-system/icons/core/youtube-play.svg'),
  'youtube': require('../../design-system/icons/core/youtube.svg'),
  'zoom': require('../../design-system/icons/core/zoom.svg'),
};

export const LOGO_ICONS = {
  'affirm-bw-logo': require('../../design-system/icons/logo/affirm-bw-logo.svg'),
  'affirm-icon-bw-logo': require('../../design-system/icons/logo/affirm-icon-bw-logo.svg'),
  'affirm-icon-logo': require('../../design-system/icons/logo/affirm-icon-logo.svg'),
  'affirm-logo': require('../../design-system/icons/logo/affirm-logo.svg'),
  'paypal-icon-logo': require('../../design-system/icons/logo/paypal-icon-logo.svg'),
  'paypal-icon-white-logo': require('../../design-system/icons/logo/paypal-icon-white-logo.svg'),
  'paypal-logo': require('../../design-system/icons/logo/paypal-logo.svg'),
};

export const NUDGE_ICONS = {
  'bell-nudge': require('../../design-system/icons/nudge/bell-nudge.svg'),
  'box-nudge': require('../../design-system/icons/nudge/box-nudge.svg'),
  'cart-nudge': require('../../design-system/icons/nudge/cart-nudge.svg'),
  'down-arrow-nudge': require('../../design-system/icons/nudge/down-arrow-nudge.svg'),
  'explore-nudge': require('../../design-system/icons/nudge/explore-nudge.svg'),
  'fast-truck-nudge': require('../../design-system/icons/nudge/fast-truck-nudge.svg'),
  'hourglass-nudge': require('../../design-system/icons/nudge/hourglass-nudge.svg'),
  'location-pin-nudge': require('../../design-system/icons/nudge/location-pin-nudge.svg'),
  'sheild-check-nudge': require('../../design-system/icons/nudge/sheild-check-nudge.svg'),
  'tag-nudge': require('../../design-system/icons/nudge/tag-nudge.svg'),
};

export const PAYMENT_CARD_ICONS = {
  'affirm-payment-card': require('../../design-system/icons/payment-card/affirm-payment-card.svg'),
  'amex-payment-card': require('../../design-system/icons/payment-card/amex-payment-card.svg'),
  'apple-pay-payment-card': require('../../design-system/icons/payment-card/apple-pay-payment-card.svg'),
  'cartes-bancaires-payment-card': require('../../design-system/icons/payment-card/cartes-bancaires-payment-card.svg'),
  'diners-club-payment-card': require('../../design-system/icons/payment-card/diners-club-payment-card.svg'),
  'discover-payment-card': require('../../design-system/icons/payment-card/discover-payment-card.svg'),
  'error-payment-card': require('../../design-system/icons/payment-card/error-payment-card.svg'),
  'google-pay-payment-card': require('../../design-system/icons/payment-card/google-pay-payment-card.svg'),
  'ideal-payment-card': require('../../design-system/icons/payment-card/ideal-payment-card.svg'),
  'jcb-payment-card': require('../../design-system/icons/payment-card/jcb-payment-card.svg'),
  'klarna-payment-card': require('../../design-system/icons/payment-card/klarna-payment-card.svg'),
  'maestro-payment-card': require('../../design-system/icons/payment-card/maestro-payment-card.svg'),
  'mastercard-payment-card': require('../../design-system/icons/payment-card/mastercard-payment-card.svg'),
  'paypal-payment-card': require('../../design-system/icons/payment-card/paypal-payment-card.svg'),
  'placeholder-payment-card': require('../../design-system/icons/payment-card/placeholder-payment-card.svg'),
  'reverb-bucks-payment-card': require('../../design-system/icons/payment-card/reverb-bucks-payment-card.svg'),
  'sepa-payment-card': require('../../design-system/icons/payment-card/sepa-payment-card.svg'),
  'sofort-payment-card': require('../../design-system/icons/payment-card/sofort-payment-card.svg'),
  'unionpay-payment-card': require('../../design-system/icons/payment-card/unionpay-payment-card.svg'),
  'visa-payment-card': require('../../design-system/icons/payment-card/visa-payment-card.svg'),
};

export const ALL_ICONS = {
  ...BRAND_ICONS,
  ...CORE_ICONS,
  ...LOGO_ICONS,
  ...NUDGE_ICONS,
  ...PAYMENT_CARD_ICONS,
};



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/icons/map.ts